import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

/** @jsx $jsx */
import { $jsx } from 'framework7';
export default (function (props, _ref) {
  var $ = _ref.$,
      $f7 = _ref.$f7,
      $f7router = _ref.$f7router,
      $f7route = _ref.$f7route,
      $update = _ref.$update,
      $on = _ref.$on;
  var hideback;
  $on('pageMounted', function () {
    hideback = !!$f7route.query.hideback;
    $update();
    var keynumber = [];
    $('.number-key').on('click', function (ev) {
      var el = $(ev.target);

      switch (el.data('number')) {
        case 'null':
          break;

        case 'back':
          console.log('back', keynumber.length);

          if (keynumber.length) {
            keynumber.pop();
          }

          break;

        default:
          if (keynumber.length == 5) {
            console.log(keynumber);
          } else if (keynumber.length == 4) {
            keynumber.push(el.data('number'));
            console.log(keynumber);
            emailInsertCode(keynumber);
          } else {
            keynumber.push(el.data('number'));
          }

      }

      $('.point').removeClass('point-fill');
      keynumber.forEach(function (e, i) {
        $('.point-' + i).addClass('point-fill');
      });
    });
  });

  var emailInsertCode = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(keynumber) {
      var resp;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return myApp.server.post('auth/set_code', {
                code: keynumber.join('')
              });

            case 2:
              resp = _context.sent;

              if (!resp.ok) {
                _context.next = 10;
                break;
              }

              _context.t0 = console;
              _context.next = 7;
              return resp.json();

            case 7:
              _context.t1 = _context.sent;

              _context.t0.log.call(_context.t0, _context.t1);

              emailVerified();

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function emailInsertCode(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var getVerifyStatus = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var resp;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return myApp.server.get('auth');

            case 3:
              resp = _context2.sent;

              if (!resp.ok) {
                _context2.next = 13;
                break;
              }

              _context2.t0 = console;
              _context2.next = 8;
              return resp.json();

            case 8:
              _context2.t1 = _context2.sent;

              _context2.t0.log.call(_context2.t0, _context2.t1);

              emailVerified();
              _context2.next = 14;
              break;

            case 13:
              console.log(resp.status);

            case 14:
              _context2.next = 19;
              break;

            case 16:
              _context2.prev = 16;
              _context2.t2 = _context2["catch"](0);
              $f7.dialog.alert('Si è verificato un errore. <br/>' + _context2.t2.message);

            case 19:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 16]]);
    }));

    return function getVerifyStatus() {
      return _ref3.apply(this, arguments);
    };
  }();

  var emailVerified = function emailVerified() {
    window.clearInterval(verifyInterval);
    $f7router.navigate('/services/', {
      clearPreviousHistory: true
    });
  };

  var verifyInterval = window.setInterval(getVerifyStatus, 3000);

  var goToHome = function goToHome() {
    localStorage.clear();
    myStorage.clear();
    window.clearInterval(verifyInterval);
    $f7router.navigate('/', {
      clearPreviousHistory: true
    });
  };

  var emailResendCode = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var resp;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return myApp.server.post('auth/send_code', {
                usr: myApp.server.authToken(),
                resend: true
              });

            case 2:
              resp = _context3.sent;

              if (resp.ok) {
                $f7.dialog.alert('Una E-mail è stata inviata a <b>' + myApp.server.authToken() + '</b>. <br> Controllare anche nella posta indesiderata ed inserire il codice. <br> ' + 'Se non si riceve l\'email entro qualche minuto controllare l\'esatezza della stessa e riprovare.');
              } else {}

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function emailResendCode() {
      return _ref4.apply(this, arguments);
    };
  }();

  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
  <div class="page">
    <div class="navbar">
      <div class="navbar-bg"></div>
      <div class="navbar-inner sliding">
        <div class="left">
          ${hideback && $h`
          <a href="#" class="link" @click=${goToHome}>
            <i class="icon f7-icons">house</i>
          </a>
          `}
          ${!hideback && $h`
          <a href="#" class="link back">
            <i class="icon icon-back"></i>
            <span class="if-not-md">Indietro</span>
          </a>
          `}
        </div>
        <div class="title">Verifica Email</div>
      </div>
    </div>
    <div class="page-content display-flex flex-direction-column justify-content-center align-items-center">
      <p>Inserisci il codice arrivato via email</p>
      <div class="unselectable" style="width: 100vw">
        <div class="row text-align-center" style="max-width: 250px; margin: 0 auto; padding: 25px 0">
          <div class="col">
            <div class="point point-0"></div>
          </div>
          <div class="col">
            <div class="point point-1"></div>
          </div>
          <div class="col">
            <div class="point point-2"></div>
          </div>
          <div class="col">
            <div class="point point-3"></div>
          </div>
          <div class="col">
            <div class="point point-4"></div>
          </div>
        </div>
        <div class="block text-align-center">
          <div class="row">
            <div class="col number-key" data-number="1">1</div>
            <div class="col number-key" data-number="2">2</div>
            <div class="col number-key" data-number="3">3</div>
          </div>
          <div class="row">
            <div class="col number-key" data-number="4">4</div>
            <div class="col number-key" data-number="5">5</div>
            <div class="col number-key" data-number="6">6</div>
          </div>
          <div class="row">
            <div class="col number-key" data-number="7">7</div>
            <div class="col number-key" data-number="8">8</div>
            <div class="col number-key" data-number="9">9</div>
          </div>
          <div class="row">
            <div class="col number-key" data-number="null"></div>
            <div class="col number-key" data-number="0">0</div>
            <div class="col number-key" data-number="back"><i class="f7-icons" data-number="back">delete_left</i></div>
          </div>
        </div>
      </div>

      <a href="#" @click=${emailResendCode} class="text-color-blue">Invia nuovamente il codice</a>
    </div>
  </div>
`
    }
    ;
});